var _rect, _path, _path2, _path3, _path4, _path5, _ellipse, _path6, _path7, _circle, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgHauntedThumbnail = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 102,
    viewBox: "0 0 104 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-background",
    x: 103.489,
    y: 0.5,
    width: 101,
    height: 101,
    rx: 10.5,
    transform: "rotate(90 103.489 0.5)",
    fill: "#294871",
    stroke: "#1E1E1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-hand-shadow",
    d: "M25.5 62C32.5722 62.8986 35.3237 61.4829 39 60.5C43.8209 45.5768 38.6599 36.9372 35.5 35.5C32.3401 34.0628 27.6457 36.1369 26.4607 38.8863C25.5127 41.0859 13.6435 41.3339 2.90873 41.4198C2.90872 59.9199 2.90873 56.4198 2.90873 56.4198L14 56.4198C14.3335 57.0837 18.4278 61.1014 25.5 62Z",
    fill: "#516D95"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9586 35.6778L102.909 9.91986C102.909 9.91986 102.909 31.4199 102.909 47.9334C102.909 64.4469 102.909 85.9198 102.909 85.9198L62.9586 60.7698C62.9586 60.7698 59.1086 55.9861 59.1086 47.9334C59.1086 39.8806 62.9586 35.6778 62.9586 35.6778Z",
    fill: "url(#paint0_linear_355_3490)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-flashlight-shadow",
    d: "M14.9087 48.2533C14.9087 44.9073 17.2961 42.0377 20.5863 41.4292L26.0093 40.4261V56.0182L20.6628 55.0911C17.3372 54.5144 14.9087 51.6285 14.9087 48.2533Z",
    fill: "#C13925"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-flashlight",
    d: "M26.0091 40.4261H52.5735V56.0182H26.0091C26.0091 56.0182 23.3783 55.2803 23.3783 48.2221C23.3783 41.164 26.0091 40.4261 26.0091 40.4261Z",
    fill: "#F75322"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-flashlight-shadow",
    d: "M73.4914 48.2221C73.4914 56.922 69.3572 63.9747 64.2573 63.9747C63.5955 63.9747 62.95 63.8559 62.3276 63.6302L57.1613 61.0872L49.8213 57.3611C48.3569 56.6178 47.1396 55.4388 46.7162 53.8521C46.3603 52.5187 46.0287 50.6485 46.0287 48.3095C46.0287 45.9284 46.3724 44.0331 46.7354 42.6954C47.1534 41.1551 48.3252 40.0012 49.7359 39.2549L57.7709 35.0041L62.3276 32.814C62.95 32.5883 63.5955 32.4695 64.2573 32.4695C69.3572 32.4695 73.4914 39.5222 73.4914 48.2221Z",
    fill: "#C13925"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "thumbnail-flashlight-lens",
    cx: 65.1499,
    cy: 48.0296,
    rx: 6.54485,
    ry: 13.5709,
    fill: "#F5C58A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-flashlight-highlight",
    d: "M56.9689 45.9122C56.9689 39.7202 59.7066 35.8917 60.3697 34.9399C56.7764 37.0574 50.1482 39.8485 48.6595 41.1319C47.1709 42.4152 47.1837 44.8534 47.0233 46.5538L56.9689 45.9122Z",
    fill: "#9A2615"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-flashlight-shadow",
    d: "M25.649 41.6356C25.7118 41.4859 25.8582 41.3885 26.0205 41.3885H45.4755C45.7489 41.3885 45.9429 41.6549 45.8589 41.9151L45.4772 43.0985C45.4235 43.2649 45.2686 43.3776 45.0938 43.3776H25.5243C25.2364 43.3776 25.0414 43.0844 25.1527 42.819L25.649 41.6356Z",
    fill: "#C13925"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.9384,
    cy: 42.5114,
    r: 1.76454,
    fill: "#22262A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.406 52.7592C59.4315 52.9802 59.632 53.1404 59.8501 53.0966C60.8955 52.8866 61.8464 52.3359 62.5504 51.525C63.3426 50.6123 63.7646 49.4361 63.7332 48.2279C63.7018 47.0197 63.2193 45.867 62.3807 44.9967C61.6356 44.2235 60.6573 43.723 59.6024 43.5675C59.3823 43.5351 59.1904 43.7055 59.1764 43.9275L58.9424 47.6359C58.9122 48.1134 58.9247 48.5927 58.9796 49.068L59.406 52.7592Z",
    fill: "#F9F2EC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-fingers",
    d: "M44.0374 50.0664C45.9775 52.2797 48.4087 55.6436 46.4087 57.1826C44.381 58.7428 42.9196 58.1023 41.3838 56.2928C42.6085 58.4143 43.0049 59.807 40.9087 60.9198C39.3057 61.7708 38.0084 61.5339 36.9099 60.6663C37.3032 61.8978 36.9422 62.9114 34.9087 63.4198C32.9749 63.9033 31.6745 63.4303 30.6537 62.4842C30.4975 62.8447 29.9792 63.1522 28.9087 63.4198C26.9087 63.9198 25.1867 62.827 23.5119 59.9785C22.3292 57.5594 20.8776 51.7143 22.4087 50.9198C23.8506 50.1716 24.5132 50.5131 25.0255 51.5271C24.7008 50.1034 24.72 48.8607 25.389 48.0942C26.4804 46.8435 28.4135 47.9194 30.4476 50.4095C29.3307 48.1706 28.7125 46.2132 29.6615 45.5815C31.6601 44.251 34.5116 46.7739 36.6424 49.2762C35.7271 47.6336 35.0227 45.8858 35.5464 44.9965C36.6253 43.1642 43.6298 49.5873 44.0374 50.0664Z",
    fill: "#6A87AE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-finger-shadows",
    d: "M24.4088 61.4198C26.5632 64.3518 28.1891 63.7981 28.9088 63.4198C23.7005 60.2377 23.4961 54.6766 22.4088 50.9198C22.4088 50.9198 20.9088 51.1336 21.4088 54.4198C21.637 55.9198 21.7157 57.7548 24.4088 61.4198Z",
    fill: "#3F5574"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-finger-shadows",
    d: "M39.3567 53.6912C42.234 58.0912 43.9087 58.9198 45.9087 57.4198C42.6149 54.7814 37.7369 48.0547 35.7096 44.7711C34.4088 45.9198 35.6585 48.036 39.3567 53.6912Z",
    fill: "#3F5574"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-hand",
    d: "M39 41.5C42 41.5 44.4128 39.2639 41.9999 37.5C39.587 35.7361 32.0001 32.5 28.5 32.5C22.9774 32.5 19.5 33 10.4351 37.9295C8.46857 39.2063 6.99992 38.546 2.90861 37.9055L2.90862 44L12.5 44C15 45.5 19.5 45.6423 21.5 45.5C25.5 45.2155 30 40.5 30 40.5C32.5913 40.5705 32.0325 40.5 34.5 40.5C36.5 40.5 36 41.5 39 41.5Z",
    fill: "#8BA2C0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-finger-shadows",
    d: "M33.4086 56.9198C37.4087 63.9198 40.9087 60.9198 40.9087 60.9198C40.9087 60.9198 32.2014 51.0515 29.4087 45.9199C28.5438 46.9666 29.0328 49.2622 33.4086 56.9198Z",
    fill: "#3F5574"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-finger-shadows",
    d: "M28.4088 59.4198C31.1642 64.6558 32.7342 63.8413 34.9087 63.4198C31.1616 59.0608 26.7193 53.7316 25.1379 48.2951C24.1936 50.8091 24.9646 52.875 28.4088 59.4198Z",
    fill: "#3F5574"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_355_3490",
    x1: 60.4087,
    y1: 47.9198,
    x2: 101.409,
    y2: 47.9198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "thumbnail-flashlight-light",
    offset: 0.285,
    stopColor: "#F9DCB9"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "thumbnail-flashlight-light",
    offset: 1,
    stopColor: "#93826D",
    stopOpacity: 0
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHauntedThumbnail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/HauntedThumbnail.f46912324e0897a727cc0787169f13cb.svg";